export interface FormattedError {
  error: any;
  message: string;
  statusCode: number;
  data: any;
  isFormatted: boolean;
}

const formatError = (err: any): FormattedError => {
  let error = err.message || 'Something went wrong';
  let message = error;
  let statusCode = 500;
  let data;
  try {
    const res = err.response.data;
    error = res.error;
    message = res.message;
    statusCode = res.statusCode;
    data = res.data || res.details;
  } catch (e) {
    console.log('e:', e);
    // take default values
  }

  if (import.meta.env.MODE !== 'production') {
    console.error(error);
  }

  return {
    error,
    message,
    statusCode,
    data,
    isFormatted: true,
  };
};

export default formatError;
